import { PIN_WIDTH, GRID_GAP } from '../utils/autoLayout';

/** Match default pin-card page width. */
export const SUGGEST_PIN_WIDTH = PIN_WIDTH;
export const SUGGEST_PIN_MIN_HEIGHT = 160;
export const SUGGEST_PIN_GRID_STRIDE = SUGGEST_PIN_WIDTH + GRID_GAP;
